"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.processTransaction = void 0;
const anchor = __importStar(require("@project-serum/anchor"));
const web3_js_1 = require("@solana/web3.js");
const utils_1 = require("@zetamarkets/flex-sdk/dist/common/utils");
const errors_1 = require("./errors");
// import { structuredErrors } from ""
async function processTransaction(provider, tx, signers, opts) {
    const blockhash = await provider.connection.getLatestBlockhash();
    tx.recentBlockhash = blockhash.blockhash;
    tx.feePayer = provider.wallet.publicKey;
    tx = await provider.wallet.signTransaction(tx);
    if (signers === undefined) {
        signers = [];
    }
    signers
        .filter((s) => s !== undefined)
        .forEach((kp) => {
        tx.partialSign(kp);
    });
    try {
        let txSig = await (0, web3_js_1.sendAndConfirmRawTransaction)(provider.connection, tx.serialize(), opts || (0, utils_1.defaultCommitment)());
        return txSig;
    }
    catch (err) {
        console.log(err);
        let translatedErr = anchor.ProgramError.parse(err, errors_1.structuredErrors);
        if (translatedErr !== null) {
            throw translatedErr;
        }
        throw err;
    }
}
exports.processTransaction = processTransaction;
